import dynamic from 'next/dynamic';

export const GridPhotoWrapper = dynamic(() => import('./GridPhotoWrapper'));
export const VerticalPaginationWrapper = dynamic(
  () => import('./VerticalPaginationWrapper'),
);
export const CarouselWrapper = dynamic(() => import('./CarouselWrapper'));
